import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-m-2 kn-overflow" }
const _hoisted_2 = {
  key: 1,
  class: "p-grid p-m-2",
  "data-test": "card-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_KnFabButton = _resolveComponent("KnFabButton")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Message = _resolveComponent("Message")
  const _component_WorkspaceCard = _resolveComponent("WorkspaceCard")
  const _component_DetailSidebar = _resolveComponent("DetailSidebar")
  const _component_Menu = _resolveComponent("Menu")
  const _component_WorkspaceAnalysisViewShareDialog = _resolveComponent("WorkspaceAnalysisViewShareDialog")
  const _component_WorkspaceAnalysisViewEditDialog = _resolveComponent("WorkspaceAnalysisViewEditDialog")
  const _component_WorkspaceWarningDialog = _resolveComponent("WorkspaceWarningDialog")
  const _component_KnInputFile = _resolveComponent("KnInputFile")
  const _component_WorkspaceCockpitDialog = _resolveComponent("WorkspaceCockpitDialog")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
      start: _withCtx(() => [
        _createVNode(_component_Button, {
          id: "showSidenavIcon",
          icon: "fas fa-bars",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('showMenu')))
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('workspace.menuLabels.myAnalysis')), 1)
      ]),
      end: _withCtx(() => [
        (_ctx.toggleCardDisplay)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              icon: "fas fa-list",
              class: "p-button-text p-button-rounded p-button-plain",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('toggleDisplayView')))
            }))
          : _createCommentVNode("", true),
        (!_ctx.toggleCardDisplay)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              icon: "fas fa-th-large",
              class: "p-button-text p-button-rounded p-button-plain",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('toggleDisplayView')))
            }))
          : _createCommentVNode("", true),
        (_ctx.user.functionalities.includes('CreateSelfSelviceCockpit') || _ctx.user.functionalities.includes('CreateSelfSelviceGeoreport') || _ctx.user.functionalities.includes('CreateSelfSelviceKpi'))
          ? (_openBlock(), _createBlock(_component_KnFabButton, {
              key: 2,
              icon: "fas fa-plus",
              "data-test": "new-folder-button",
              onClick: _ctx.showCreationMenu
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          mode: "indeterminate",
          class: "kn-progress-bar"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_InputText, {
      class: "kn-material-input p-m-2",
      style: _ctx.mainDescriptor.style.filterInput,
      modelValue: _ctx.searchWord,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.searchWord = $event)),
      type: "text",
      placeholder: _ctx.$t('common.search'),
      onInput: _ctx.searchItems,
      "data-test": "search-input"
    }, null, 8, ["style", "modelValue", "placeholder", "onInput"]),
    _createVNode("div", _hoisted_1, [
      (!_ctx.toggleCardDisplay)
        ? (_openBlock(), _createBlock(_component_DataTable, {
            key: 0,
            class: "p-datatable-sm kn-table p-mx-2",
            value: _ctx.filteredAnalysisDocuments,
            loading: _ctx.loading,
            dataKey: "id",
            responsiveLayout: "stack",
            breakpoint: "600px",
            "data-test": "analysis-table"
          }, {
            empty: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
            ]),
            filter: _withCtx(({ filterModel }) => [
              _createVNode(_component_InputText, {
                type: "text",
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
                class: "p-column-filter"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                field: "name",
                header: _ctx.$t('importExport.gallery.column.name'),
                sortable: true
              }, null, 8, ["header"]),
              _createVNode(_component_Column, {
                field: "creationUser",
                header: _ctx.$t('kpi.targetDefinition.kpiAuthor'),
                sortable: true
              }, null, 8, ["header"]),
              _createVNode(_component_Column, {
                field: "creationDate",
                header: _ctx.$t('kpi.targetDefinition.kpiDate'),
                sortable: true
              }, {
                body: _withCtx(({data}) => [
                  _createTextVNode(_toDisplayString(_ctx.formatDate(data.creationDate)), 1)
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_Column, {
                style: _ctx.mainDescriptor.style.iconColumn
              }, {
                body: _withCtx((slotProps) => [
                  _createVNode(_component_Button, {
                    icon: "fas fa-ellipsis-v",
                    class: "p-button-link",
                    onClick: ($event: any) => (_ctx.showMenu($event, slotProps.data))
                  }, null, 8, ["onClick"]),
                  _withDirectives(_createVNode(_component_Button, {
                    icon: "fas fa-info-circle",
                    class: "p-button-link",
                    onClick: ($event: any) => (_ctx.showSidebar(slotProps.data)),
                    "data-test": 'info-button-' + slotProps.data.name
                  }, null, 8, ["onClick", "data-test"]), [
                    [
                      _directive_tooltip,
                      _ctx.$t('workspace.myModels.showInfo'),
                      void 0,
                      { left: true }
                    ]
                  ]),
                  _createVNode(_component_Button, {
                    icon: "fas fa-play-circle",
                    class: "p-button-link",
                    onClick: ($event: any) => (_ctx.executeAnalysisDocument(slotProps.data))
                  }, null, 8, ["onClick"])
                ]),
                _: 1
              }, 8, ["style"])
            ]),
            _: 1
          }, 8, ["value", "loading"]))
        : _createCommentVNode("", true),
      (_ctx.toggleCardDisplay)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            (_ctx.filteredAnalysisDocuments.length === 0)
              ? (_openBlock(), _createBlock(_component_Message, {
                  key: 0,
                  class: "kn-flex p-m-2",
                  severity: "info",
                  closable: false,
                  style: _ctx.mainDescriptor.style.message
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
                  ]),
                  _: 1
                }, 8, ["style"]))
              : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.filteredAnalysisDocuments, (document, index) => {
                  return (_openBlock(), _createBlock(_component_WorkspaceCard, {
                    key: index,
                    viewType: 'analysis',
                    document: document,
                    onExecuteAnalysisDocument: _ctx.executeAnalysisDocument,
                    onEditAnalysisDocument: _ctx.openKpiDesigner,
                    onShareAnalysisDocument: _ctx.shareAnalysisDocument,
                    onCloneAnalysisDocument: _ctx.cloneAnalysisDocument,
                    onDeleteAnalysisDocument: _ctx.deleteAnalysisDocumentConfirm,
                    onUploadAnalysisPreviewFile: _ctx.uploadAnalysisPreviewFile,
                    onOpenSidebar: _ctx.showSidebar
                  }, null, 8, ["document", "onExecuteAnalysisDocument", "onEditAnalysisDocument", "onShareAnalysisDocument", "onCloneAnalysisDocument", "onDeleteAnalysisDocument", "onUploadAnalysisPreviewFile", "onOpenSidebar"]))
                }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_DetailSidebar, {
      visible: _ctx.showDetailSidebar,
      viewType: 'analysis',
      document: _ctx.selectedAnalysis,
      onExecuteAnalysisDocument: _ctx.executeAnalysisDocument,
      onEditAnalysisDocument: _ctx.editAnalysisDocument,
      onShareAnalysisDocument: _ctx.shareAnalysisDocument,
      onCloneAnalysisDocument: _ctx.cloneAnalysisDocumentConfirm,
      onDeleteAnalysisDocument: _ctx.deleteAnalysisDocumentConfirm,
      onUploadAnalysisPreviewFile: _ctx.uploadAnalysisPreviewFile,
      onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showDetailSidebar = false)),
      "data-test": "detail-sidebar"
    }, null, 8, ["visible", "document", "onExecuteAnalysisDocument", "onEditAnalysisDocument", "onShareAnalysisDocument", "onCloneAnalysisDocument", "onDeleteAnalysisDocument", "onUploadAnalysisPreviewFile"]),
    _createVNode(_component_Menu, {
      id: "optionsMenu",
      ref: "optionsMenu",
      model: _ctx.menuButtons
    }, null, 8, ["model"]),
    _createVNode(_component_Menu, {
      id: "creationMenu",
      ref: "creationMenu",
      model: _ctx.creationMenuButtons
    }, null, 8, ["model"]),
    _createVNode(_component_WorkspaceAnalysisViewShareDialog, {
      visible: _ctx.shareDialogVisible,
      propFolders: _ctx.folders,
      onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.shareDialogVisible = false)),
      onShare: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleAnalysShared($event, false)))
    }, null, 8, ["visible", "propFolders"]),
    _createVNode(_component_WorkspaceAnalysisViewEditDialog, {
      visible: _ctx.editDialogVisible,
      propAnalysis: _ctx.selectedAnalysis,
      onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.editDialogVisible = false)),
      onSave: _ctx.handleEditAnalysis
    }, null, 8, ["visible", "propAnalysis", "onSave"]),
    _createVNode(_component_WorkspaceWarningDialog, {
      visible: _ctx.warningDialogVisbile,
      title: _ctx.$t('workspace.menuLabels.myAnalysis'),
      warningMessage: _ctx.warningMessage,
      onClose: _ctx.closeWarningDialog
    }, null, 8, ["visible", "title", "warningMessage", "onClose"]),
    (!_ctx.uploading)
      ? (_openBlock(), _createBlock(_component_KnInputFile, {
          key: 1,
          changeFunction: _ctx.uploadAnalysisFile,
          accept: "image/*",
          triggerInput: _ctx.triggerUpload
        }, null, 8, ["changeFunction", "triggerInput"]))
      : _createCommentVNode("", true),
    _createVNode(_component_WorkspaceCockpitDialog, {
      visible: _ctx.cockpitDialogVisible,
      onClose: _ctx.closeCockpitDialog
    }, null, 8, ["visible", "onClose"])
  ], 64))
}